/* Vista Panel de Control para /eventos/:id
Vista que trae toda la info del evento, muestra el dashboard de tarifas vendidas y sus accesos */
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loading from "../../components/Loading";
import { api } from "../../services/api";
import { useParams } from "react-router-dom";
import { Container } from "reactstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, } from 'chart.js';
import { useMediaQuery } from "react-responsive";
import { FastfoodOutlined, ConfirmationNumberOutlined, HowToRegOutlined, PendingActionsOutlined, DateRangeOutlined } from "@mui/icons-material";
import LinearProgress from '@mui/material/LinearProgress';
import { toast, Bounce } from 'react-toastify';
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";
import VendedorDashboard from "./VentaPresencial";
import ResumenCaja from "./ResumenCaja";
import { UserContext } from "../../components/ProtectedRoutes/UserContext";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale);

export const Evento = () => {
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null,
  });
  const history = useHistory();
  const [evento, setEvento] = useState();
  const [stateEvento, setStateEvento] = useState();
  const [eventosumary, setEventoSumary] = useState();
  const [publicaciones, setPublicaciones] = useState();
  const [tarifas, setTarifas] = useState();
  const { userRole, setUserRole } = useContext(UserContext);
  const [rolUsuario, setRolUsuario] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);
  const param = useParams();
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });

  const [filteredTickets, setFilteredTickets] = useState([]);
  const [filteredVouchers, setFilteredVouchers] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0]
  );

  const [availableDates, setAvailableDates] = useState([]);


  useEffect(() => {

    const callApi = async () => {
      try {
        setLoading(true);
        const response = await api.eventos.get(param.id);
        if (response.status === "success") {
          setEvento(response.data.evento);
          setEventoSumary(response.data.eventosumary);

          const allTickets = response.data.eventosumary.tickets || [];
          const allVouchers = response.data.eventosumary.vouchers || [];

          setTickets(allTickets);
          setVouchers(allVouchers);

          // fechas del evento
          const allDates = new Set();

          allTickets.forEach(ticket => {
            if (ticket.fechas_asignadas && Array.isArray(ticket.fechas_asignadas)) {
              ticket.fechas_asignadas.forEach(fecha => {
                if (fecha) allDates.add(fecha);
              });
            }
          });

          allVouchers.forEach(voucher => {
            if (voucher.fechas_asignadas && Array.isArray(voucher.fechas_asignadas)) {
              voucher.fechas_asignadas.forEach(fecha => {
                if (fecha) allDates.add(fecha);
              });
            }
          });

          const sortedDates = Array.from(allDates).sort();

          const today = new Date().toISOString().split('T')[0];
          let initialDate = sortedDates.includes(today) ? today : sortedDates[0];

          setAvailableDates(sortedDates);

          if (sortedDates.length > 0) {
            setSelectedDate(initialDate);
            filterByDate(allTickets, allVouchers, initialDate);
          } else {
            filterByDate(allTickets, allVouchers, selectedDate);
          }

          setStateEvento(response.data.evento.id_estados_eventos);
          setPublicaciones(response.data.publicacionessumary);
          setTarifas(response.data.tarifassumary);

          const participacionesResponse = await api.participaciones.getParticipaciones();

          if (participacionesResponse.status === 'success' && participacionesResponse.data?.participaciones) {
            //traigo el rol del usuario para mostrar distintos dashboard
            const participacion = participacionesResponse.data.participaciones.find(
              p => p.idevento.toString() === param.id
            );

            if (participacion) {
              setUserRole(participacion.idrol);

              if (participacion.rol?.rol === "Vendedor") {
                setRolUsuario("Vendedor");
              } else if (participacion.rol?.rol === "Tesorero") {
                setRolUsuario("Tesorero");
              } else {
                setRolUsuario("Owner");
              }
            }
          }
        }
      } catch (error) {
        setState({
          ...state,
          error: "Error en la Red.",
        });
      } finally {
        setLoading(false);
      }
    };
    callApi();
  }, [param.id, setUserRole]);

  useEffect(() => {
    if (tickets && tickets.length > 0) {
      filterByDate(tickets, vouchers, selectedDate);
    }
  }, [selectedDate]);


  const filterByDate = (allTickets, allVouchers, date) => {
    if (!date) return;

    const ticketsForDate = allTickets?.filter(ticket =>
      ticket.fechas_asignadas && ticket.fechas_asignadas.includes(date)
    ) || [];

    const vouchersForDate = allVouchers?.filter(voucher =>
      voucher.fechas_asignadas && voucher.fechas_asignadas.includes(date)
    ) || [];

    const ticketsWithCalculatedStats = ticketsForDate.map(ticket => {
      const updatedTicket = { ...ticket };

      let escaneadosAcumulados = ticket.escaneados || 0;
      let escaneadosEnFecha = 0;

      if (ticket.escaneos_por_fecha && ticket.escaneos_por_fecha.length > 0) {
        escaneadosAcumulados = 0;

        ticket.escaneos_por_fecha.forEach(escaneo => {
          if (escaneo.fecha <= date) {
            escaneadosAcumulados += escaneo.escaneados;

            // if (escaneo.fecha === date) {
            escaneadosEnFecha = escaneo.escaneados;
            // }
          }
        });
      }

      updatedTicket.escaneadosAcumulados = escaneadosAcumulados;
      updatedTicket.escaneadosEnFecha = escaneadosEnFecha;
      updatedTicket.pendientes = ticket.cantidad - escaneadosAcumulados;

      return updatedTicket;
    });

    // stats de los vouchers como los tickets
    const vouchersWithCalculatedStats = vouchersForDate.map(voucher => {
      const updatedVoucher = { ...voucher };

      let escaneadosAcumulados = voucher.escaneados || 0;
      let escaneadosEnFecha = 0;

      if (voucher.escaneos_por_fecha && voucher.escaneos_por_fecha.length > 0) {
        escaneadosAcumulados = 0;

        voucher.escaneos_por_fecha.forEach(escaneo => {
          if (escaneo.fecha <= date) {
            escaneadosAcumulados += escaneo.escaneados;

            if (escaneo.fecha === date) {
              escaneadosEnFecha = escaneo.escaneados;
            }
          }
        });
      }

      updatedVoucher.escaneadosAcumulados = escaneadosAcumulados;
      updatedVoucher.escaneadosEnFecha = escaneadosEnFecha;
      updatedVoucher.pendientes = voucher.cantidad - escaneadosAcumulados;

      return updatedVoucher;
    });

    setFilteredTickets(ticketsWithCalculatedStats);
    setFilteredVouchers(vouchersWithCalculatedStats);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleFinalizarConfiguracion = () => {
    if (evento.privado === false && tarifas.count === 0) {
      history.push(`/eventos/${param.id}/tarifas`);
    } else if (evento.privado === false && publicaciones.count === 0) {
      history.push(`/eventos/${param.id}/publicaciones`);
    } else {
      api.eventos.confirmEvento(param.id)
        .then(response => {
          if (response.status === 'success') {
            toast.success('Tu evento se ha publicado exitosamente', {
              position: 'top-center',
              autoClose: 2000,
              theme: 'dark',
              transition: Bounce,
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        })
        .catch(error => {
          toast.error('Hubo un problema al confirmar el evento', {
            position: 'top-center',
            autoClose: 3000,
            theme: 'dark',
          });
        });
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(`${dateString}T12:00:00`);

    if (isNaN(date.getTime())) {
      return dateString;
    }

    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    return date.toLocaleDateString('es-ES', options);
  };

  return (
    <>
      {evento && !loading && (
        <Container fluid="sm">
          {rolUsuario === "Vendedor" ? (
            <>
              <VendedorDashboard eventoId={param.id} evento={evento} />
            </>
          ) : rolUsuario === "Tesorero" ? (
            <>
              <ResumenCaja eventoId={param.id} evento={evento} />
            </>
          ) : (
            <>
              {stateEvento === 1 ? (
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <div style={{ width: "90%" }}>
                    <div className="" style={{ color: "#8C2828", border: "1px solid #D02A2A", borderRadius: "5px", padding: "20px 15px", backgroundColor: "rgba(255, 180, 180, 0.2)" }}>
                      <div className="">
                        <p className="mb-2 fw-bold fs-4"> {(evento.privado === false && tarifas.count === 0) || (evento.privado === false && publicaciones.count === 0)
                          ? "Tu evento no está listo"
                          : "Evento listo para publicar"}</p>
                        <p className="mb-1 fs-6" style={{ color: "#8C2828" }}>
                          {evento.privado === false
                            ? (
                              tarifas.count === 0 && publicaciones.count === 0
                                ? "Tu evento no tiene tarifas ni publicaciones configuradas. Completa estos detalles para que el evento esté listo para ser publicado."
                                : (tarifas.count === 0
                                  ? "Aún no has configurado tarifas para tu evento. Por favor, agrega al menos una tarifa para publicar el evento."
                                  : (publicaciones.count === 0
                                    ? "Aún no has creado una publicación para tu evento. Agrega una publicación para que los usuarios puedan verlo."
                                    : null
                                  )
                                )
                            )
                            : (
                          /* tarifas.count === 0
                            ? "Aún no has configurado tarifas para tu evento. Por favor, agrega al menos una tarifa para publicar el evento."
                            : */ null
                            )
                          }
                        </p>
                        <div className="d-flex align-items-center justify-content-end">
                          <button type="button" onClick={handleFinalizarConfiguracion} style={{ color: "#3D2EAB" }}>
                            {(evento.privado === false && tarifas.count === 0) || (evento.privado === false && publicaciones.count === 0)
                              ? "Finalizar configuración"
                              : "Publicar evento"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "30px", padding: "0px 25px", flexDirection: "column", height: "100%" }}>
                    <div className="d-flex justify-content-end mb-3">
                      {availableDates.length > 0 && (
                        <div className="date-selector-container" style={{
                          padding: "10px",
                          borderRadius: "8px",
                          boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <DateRangeOutlined sx={{ color: "#3D2EAB", marginRight: "8px" }} />
                          <select
                            value={selectedDate}
                            onChange={handleDateChange}
                            className="form-select"
                            style={{ border: "none", boxShadow: "none", minWidth: "200px" }}
                          >
                            {availableDates.map(date => (
                              <option key={date} value={date}>
                                {formatDateDisplay(date)}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>

                    <div className="d-flex flex-column">
                      <p style={{ fontSize: "28px", marginBottom: "0px" }}>Tickets</p>
                      {filteredTickets?.length > 0 ? (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                          {filteredTickets?.map((tarifa, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                                width: isMobile ? "100%" : "225px",
                                borderRadius: "12px",
                              }}
                            >
                              <div style={{ padding: "20px 15px", display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%" }}>
                                <div className="d-flex flex-row align-items-center justify-content-between">
                                  <div className="d-flex flex-column">
                                    <p style={{ marginBottom: "0", fontSize: "14px", lineHeight: "22px", letterSpacing: "0.15px" }}>
                                      {tarifa.concepto}
                                    </p>
                                    <p style={{ fontSize: "28px", lineHeight: "32px" }}>{tarifa.cantidad}</p>
                                  </div>
                                  <div
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      borderRadius: "50%",
                                      marginBottom: "10px",
                                      backgroundColor: "#e4f3fc",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <ConfirmationNumberOutlined sx={{ fontSize: "30px", color: "#067bea" }} />
                                  </div>
                                </div>
                                <div>
                                  <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                    Acreditados
                                  </p>
                                  <div className="d-flex flex-row align-items-center">
                                    <HowToRegOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                    <LinearProgress
                                      variant="determinate"
                                      value={tarifa.escaneadosAcumulados}/* {(availableDates.length > 1 ? tarifa.escaneadosEnFecha : tarifa.escaneadosAcumulados) / tarifa.cantidad * 100} */
                                      sx={{
                                        height: "10px !important",
                                        width: isMobile ? "75%" : "140px",
                                        minWidth: isMobile ? "75%" : "140px",
                                        maxWidth: isMobile ? "75%" : "140px",
                                        borderRadius: "5px",
                                        backgroundColor: "#F5F5F5",
                                        '& .MuiLinearProgress-bar': {
                                          backgroundColor: '#9797E4',
                                          borderRadius: "5px"
                                        },
                                      }}
                                    />
                                    <div className="ml-auto">
                                      <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                        {/* {availableDates.length > 1 ? tarifa.escaneadosEnFecha : tarifa.escaneadosAcumulados} */}
                                        {tarifa.escaneadosAcumulados}
                                      </p>
                                    </div>
                                  </div>
                                  <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                    Pendientes
                                  </p>
                                  <div className="d-flex flex-row  align-items-center">
                                    <PendingActionsOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                    <LinearProgress
                                      variant="determinate"
                                      value={(tarifa.pendientes / tarifa.cantidad) * 100}
                                      sx={{
                                        height: "10px !important",
                                        width: isMobile ? "75%" : "140px",
                                        minWidth: isMobile ? "75%" : "140px",
                                        maxWidth: isMobile ? "75%" : "140px",
                                        borderRadius: "5px",
                                        backgroundColor: "#F5F5F5",
                                        '& .MuiLinearProgress-bar': {
                                          backgroundColor: '#4837C5',
                                          borderRadius: "5px"
                                        },
                                      }}
                                    />
                                    <div className="ml-auto">

                                      <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                        {tarifa.pendientes || 0}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "between",
                            alignItems: "center",
                            boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                            width: "250px",
                            height: "auto",
                            borderRadius: "12px",
                            padding: "20px"
                          }}>
                          <p style={{ marginBottom: "0", fontSize: "16px", lineHeight: "20px", letterSpacing: "0.15px" }}>Aun no tienes tickets registrados</p>
                          <div
                            style={{
                              width: "55px",
                              height: "45px",
                              borderRadius: "50%",
                              backgroundColor: "#e4f3fc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <ConfirmationNumberOutlined sx={{ fontSize: "20px", color: "#067bea" }} />
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="d-flex flex-column">
                      {filteredVouchers?.length > 0 && (
                        <>
                          <p style={{ fontSize: "28px", marginBottom: "0px" }}>Venta Presencial</p>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", flexDirection: "row" }}>
                            {filteredVouchers?.map((tarifa, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                                  width: isMobile ? "100%" : "225px",
                                  borderRadius: "12px",
                                }}
                              >
                                <div style={{ padding: "20px 15px", display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%" }}>
                                  <div className="d-flex flex-row align-items-center justify-content-between">
                                    <div className="d-flex flex-column">
                                      <p style={{ marginBottom: "0", fontSize: "14px", lineHeight: "22px", letterSpacing: "0.15px" }}>
                                        {tarifa.concepto}
                                      </p>
                                      <p style={{ fontSize: "28px", lineHeight: "32px" }}>{tarifa.cantidad}</p>
                                    </div>
                                    <div
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "50%",
                                        marginBottom: "10px",
                                        backgroundColor: "#e4f3fc",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <FastfoodOutlined sx={{ fontSize: "30px", color: "#067bea" }} />
                                    </div>
                                  </div>
                                  <div>
                                    <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                      Reclamados
                                    </p>
                                    <div className="d-flex flex-row justify-content-around align-items-center">
                                      <HowToRegOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                      <LinearProgress
                                        variant="determinate"
                                        value={(availableDates.length > 1 ? tarifa.escaneadosEnFecha : tarifa.escaneadosAcumulados) / tarifa.cantidad * 100}
                                        sx={{
                                          height: "10px !important",
                                          width: isMobile ? "75%" : "140px",
                                          minWidth: isMobile ? "75%" : "140px",
                                          maxWidth: isMobile ? "75%" : "140px",
                                          borderRadius: "5px",
                                          backgroundColor: "#F5F5F5",
                                          '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#9797E4',
                                            borderRadius: "5px"
                                          },
                                        }}
                                      />
                                      <div className="ml-auto">
                                        <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                          {availableDates.length > 1 ? tarifa.escaneadosEnFecha : tarifa.escaneadosAcumulados}
                                        </p>
                                      </div>
                                    </div>
                                    <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                      Pendientes
                                    </p>
                                    <div className="d-flex flex-row justify-content-around align-items-center">
                                      <PendingActionsOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                      <LinearProgress
                                        variant="determinate"
                                        value={((tarifa.cantidad - tarifa.escaneados) / tarifa.cantidad) * 100}
                                        sx={{
                                          height: "10px !important",
                                          width: isMobile ? "75%" : "140px",
                                          minWidth: isMobile ? "75%" : "140px",
                                          maxWidth: isMobile ? "75%" : "140px",
                                          borderRadius: "5px",
                                          backgroundColor: "#F5F5F5",
                                          '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#4837C5',
                                            borderRadius: "5px"
                                          },
                                        }}
                                      />
                                      <div className="ml-auto">
                                        <p style={{ color: "black", fontSize: "18px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                          {tarifa.cantidad - tarifa.escaneados}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          )}

        </Container >
      )}
    </>
  );
};
export default withAuthenticationRequired(Evento, {
  onRedirecting: () => <Loading />,
});